import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/Auth';
import Logo from './Logo';

/**
 * The way in.
 *
 * There is no "create an account" and no "forgot password". Accounts come from
 * the owner, either on the server or as an invite code (the quiet "Have an
 * invite?" link below leads to /signup, which asks for the code before
 * anything else), and there is no email address on file to send a reset to:
 * the admin resets passwords from /admin.
 */
const Login = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // Where they were headed before being sent here, so signing in resumes the
  // journey rather than dumping everyone on the home page.
  const target = location.state?.from || '/home';

  const submit = async (event) => {
    event.preventDefault();
    if (busy) return;

    setBusy(true);
    setError('');

    try {
      await signIn(username, password);
      navigate(target, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Could not sign in. Try again.');
      setPassword('');
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          <Logo />
        </div>

        <h1 className="login-title">Sign in</h1>

        <label className="login-field">
          <span className="login-k">Username</span>
          <input
            type="text"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck="false"
            autoFocus
            required
          />
        </label>

        <label className="login-field">
          <span className="login-k">Password</span>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {error && <div className="alert login-alert">{error}</div>}

        <button type="submit" className="btn btn--play login-submit" disabled={busy}>
          {busy ? <span className="play-spin" /> : null}
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <Link to="/signup" className="login-aside">
          Have an invite?
        </Link>
      </form>
    </div>
  );
};

export default Login;
